import { ValidateFunction } from "ajv";
import { ConditionExpression } from "../../models";
import { collectAjvErrorDetails } from "./ajvErrorFormatting";

export function validateConditionSchema(
  conditionValidator: ValidateFunction,
  condition: unknown,
): string[] {
  return conditionValidator(condition)
    ? []
    : collectAjvErrorDetails(conditionValidator.errors);
}

export function isConditionSchemaValid(
  conditionValidator: ValidateFunction,
  condition: unknown,
): condition is ConditionExpression {
  return conditionValidator(condition) as boolean;
}
